var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8801 11.9427L41.5573 16.6177L36.8801 11.9427ZM39.8878 7.82412L27.2407 20.4712C26.5872 21.1238 26.1416 21.9552 25.9599 22.8607L24.7917 28.7083L30.6393 27.5379C31.5448 27.3568 32.3751 26.913 33.0288 26.2593L45.6759 13.6122C46.0559 13.2321 46.3574 12.7809 46.5631 12.2844C46.7688 11.7878 46.8746 11.2556 46.8746 10.7181C46.8746 10.1807 46.7688 9.64847 46.5631 9.15191C46.3574 8.65535 46.0559 8.20417 45.6759 7.82412C45.2958 7.44408 44.8447 7.14261 44.3481 6.93692C43.8515 6.73124 43.3193 6.62538 42.7819 6.62538C42.2444 6.62538 41.7122 6.73124 41.2156 6.93692C40.7191 7.14261 40.2679 7.44408 39.8878 7.82412V7.82412Z",
    stroke: "url(#paint0_linear_5_66)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4583 33.125V39.75C42.4583 40.9214 41.993 42.0448 41.1647 42.8731C40.3364 43.7013 39.213 44.1667 38.0417 44.1667H13.75C12.5786 44.1667 11.4552 43.7013 10.6269 42.8731C9.79866 42.0448 9.33334 40.9214 9.33334 39.75V15.4583C9.33334 14.287 9.79866 13.1636 10.6269 12.3353C11.4552 11.507 12.5786 11.0417 13.75 11.0417H20.375",
    stroke: "url(#paint1_linear_5_66)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_66",
    x1: 46.8746,
    y1: 28.7083,
    x2: 27.645,
    y2: 4.37088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_66",
    x1: 42.4583,
    y1: 44.1667,
    x2: 13.6134,
    y2: 7.65986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BFF7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.10f6ad6b0355ab00996bc0aafe1bfc2a.svg";
export { ForwardRef as ReactComponent };